import { Observable } from "rxjs";
import { Subscription } from "../../model/Subscription";
import apiService from "../ApiService";
import { UserProfile } from "../../model";

export const getFamilyInfo = (): Observable<{
  subscription?: Subscription;
  profiles: UserProfile[];
}> => {
  return apiService.get<{ subscription: Subscription; profiles: UserProfile[] }>({
    path: `v1/family`,
    requiresAuthPolicy: "family",
  });
};
